import React from 'react';
import { GeoIndicationPatchMutation } from '../graphql/mutations/GeoIndicationPatchMutation';
import { GeoIndicationEditQuery } from '../graphql/query/GeoIndicationEditQuery';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/GeoIndication.json';
import inputTypeIntro from '../static/introspection/GeoIndicationPatchInput.json';
import { graphqlQuery } from '../utils/graphql';
import { ENTITY } from '../utils/entities';
import { UserData } from '@food/auth';

export const GeoIndicationEdit = ({ id }) => (
	<UserData>
		{({ isInternal }) => (
			<EntityEditFetcher
				fetcher={graphqlQuery(GeoIndicationEditQuery, { id })}
				mutation={GeoIndicationPatchMutation}
				entityName={ENTITY.GEO_INDICATION}
				typeIntro={typeIntro}
				inputTypeIntro={inputTypeIntro}
				id={id}
				fields={[
					isInternal ? 'sfId' : null,
					'name',
					'logoMedia',
					'akas',
					'descriptionValues',
					'vatNumber',
					'website',
					'socialInstagramPage',
					'socialFacebookPage',
					'Country',
					'StateProvince',
					'postalCode',
					'city',
					'address1',
					'address2',
					'lat',
					'lng',
					'companies',
				]}
			/>
		)}
	</UserData>
);
